import { IonContent } from '@ionic/react';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { PaymentModal } from '@/modals/Payment';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { PaywallFixedTimer } from '@/pages/Paywall/sections/FixedTimer';
import { PaywallGuaranteePeriod } from '@/pages/Paywall/sections/GuaranteePeriod';
import { PaywallSectionImageWithData } from '@/pages/Paywall/sections/ImageWithData';
import { PaywallSectionSelectPlan } from '@/pages/Paywall/sections/SelectPlan';

import { PaywallV2Styles } from './PaywallV2.styles';
import { OnboardingPaywallAINumber } from './sections/AINumber';
import { OnboardingPaywallHowItWorks } from './sections/HowItWorks';
import { OnboardingPaywallUsersReviews } from './sections/UsersReviews';
import { OnboardingPaywallWhatYouGet } from './sections/WhatYouGet';

const PaywallV2: React.FC = () => {
  return (
    <PaywallV2Styles>
      <PaywallFixedTimer />

      <IonContent>
        <PaywallSectionImageWithData />

        <PaywallSectionSelectPlan title={null} />

        <OnboardingPaywallAINumber />

        <OnboardingPaywallWhatYouGet />

        <OnboardingPaywallUsersReviews />

        <OnboardingPaywallHowItWorks />

        <PaywallSectionSelectPlan
          title={
            <OnboardingTitle>
              Your Сustom{' '}
              <UiTypography variant="inherit" color="gradient" component="span">
                Super Dialogue Plan
              </UiTypography>{' '}
              is ready!
            </OnboardingTitle>
          }
        />

        <PaywallGuaranteePeriod />
      </IonContent>

      <PaymentModal />
    </PaywallV2Styles>
  );
};

export default PaywallV2;
